import { Input, type InputProps } from '@progress/kendo-react-inputs'
import classNames from 'classnames'
import React from 'react'

import { Box } from '~/components/elements/Box'
import { Icon } from '~/components/elements/Icon'

import styles from './SearchInput.css'

export type SearchInputProps = {
  className?: string
  'data-testid'?: string
  value?: string
  onChange?: (value: string) => void
}

export const SearchInput = ({
  className,
  'data-testid': dataTestId = 'components-elements-search-input',
  onChange,
  value,
}: SearchInputProps) => {
  const handleChange = React.useCallback<EH<InputProps, 'onChange'>>(
    (event) => {
      onChange?.(event.value)
    },
    [onChange],
  )

  return (
    <Box
      className={classNames(styles.root, className)}
      data-testid={dataTestId}
    >
      <Input value={value} onChange={handleChange} />

      <Icon icon="search" size="1rem" />
    </Box>
  )
}
